import { render, staticRenderFns } from "./InquiryDetailPayer.vue?vue&type=template&id=19108867"
import script from "./InquiryDetailPayer.vue?vue&type=script&lang=js"
export * from "./InquiryDetailPayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports